var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card"},[_c('v-card',{class:{'is-disabled': _vm.isDisabled},attrs:{"outlined":""}},[_c('v-card-text',{staticClass:"px-0 py-0"},[_vm._t("body")],2)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }